const messages_es = {
	'login.welcome': 'Bienvenido, inicia sesión',
	'logout.title': 'Cerrar sesión',

	'commons.insurer': 'Aseguradora',
	'commons.reinsurer': 'Reasegurador',

	'commons.back': 'Regresar',
	'commons.save': 'Guardar',
	'commons.validate': 'Validar',
	'commons.update': 'Actualizar',
	'commons.rowsPerPage': 'Filas por página',
	'commons.of': 'de',
	'commons.noData': 'No se encontraron registros',
	'commons.step': 'Paso',
	'commons.filter': 'Filtrar...',
	'commons.dragAndDrop': 'Da click o arrastra el archivo aquí',
	'commons.findNumber': 'Buscar número',
	'commons.initDate': 'Fecha inicial',
	'commons.endDate': 'Fecha final',
	'commons.downloadAll': 'Descargar todos',
	'commons.consolidated': 'Consolidado',
	'commons.status': 'Estatus',
	'commons.apply': 'Aplicar',
	'commons.credits': 'Créditos',
	'commons.next': 'Siguiente',
	'commons.download': 'Descargar',
	'commons.have': 'Tienes',
	'commons.error': 'error(es)',
	'commons.required': 'Campo requerido',
	'commons.textQuantity': 'Cantidad de caracteres:',
	'commons.start': 'Iniciar',
	'commons.daily': 'Diario',
	'commons.weekly': 'Semanal',
	'commons.biweekly': 'Quincenal',
	'commons.monthly': 'Mensual',
	'commons.company_supervisor': 'Supervisor',
	'commons.customer': 'Cliente',
	'commons.downloading': 'Descargando',
	'commons.root': 'root',
	'commons.add': 'Añadir',
	'commons.yes': 'Sí',
	'commons.contactUs': 'Contáctanos',
	'commons.suscribeMe': 'Suscribirme',
	'commons.goToPay': 'Ir al pago',
	'commons.mxn': ' ',

	'month.enero': 'Enero',
	'month.febrero': 'Febrero',
	'month.marzo': 'Marzo',
	'month.abril': 'Abril',
	'month.mayo': 'Mayo',
	'month.junio': 'Junio',
	'month.julio': 'Julio',
	'month.agosto': 'Agosto',
	'month.septiembre': 'Septiembre',
	'month.octubre': 'Octubre',
	'month.noviembre': 'Noviembre',
	'month.diciembre': 'Diciembre',

	'table.name': 'Nombre',
	'table.email': 'Correo',
	'table.phone': 'Teléfono',
	'table.membership': 'Membresía',
	'table.createdAt': 'Miembro desde',
	'table.membershipType': 'Tipo de membresía',
	'table.police': 'Póliza',
	'table.options': 'Opciones',
	'table.seller': 'Guía Wilma',
	'table.status': 'Estatus',
	'table.actions': 'Acciones',
	'table.date': 'Fecha',
	'table.memberId': 'ID de miembro',
	'table.guideId': 'ID de guía',
	'table.allyId': 'ID de aliado',
	'table.ally': 'Aliado Wilma',
	'table.discount': 'Descuento',
	'table.company': 'Compañía',
	'table.insuredAmount': 'Monto asegurado',
	'table.premiumAmount': 'Monto prima total',
	'table.city': 'Ciudad',
	'table.premium': 'Prima',
	'table.folio': 'Folio',

	'opt.delete': 'Eliminar',
	'opt.edit': 'Editar',
	'opt.credits': 'Cargar créditos',
	'opt.downloadReport': 'Descargar reporte',
	'opt.downloadAudio': 'Descargar audio',
	'opt.downloadFile': 'Descargar archivo',
	'opt.clone': 'Clonar campaña',
	'opt.moreThan100': 'Más de 100',
	'opt.to': 'a',
	'opt.businessLine.1': 'Hospedaje/Restaurantes y Eventos',
	'opt.businessLine.2': 'Transporte',
	'opt.businessLine.3': 'Tour Operador y Proveedor de Experiencias',
	'opt.businessLine.4': 'Servicios en Playa',
	'opt.businessLine.5': 'Renta de Propiedades Vacacionales',
	'opt.businessLine.6': 'Bienes Raices y Administración de Propiedades',
	'opt.businessLine.7': 'Cultura',
	'opt.businessLine.8': 'Servicios de Salud',
	'opt.businessLine.9': 'Asesoría',
	'opt.businessLine.10': 'Locales Comerciales',
	'opt.businessLine.12': 'Casa Habitación',
	'opt.businessLine.11': 'Otros',
	'opt.customized': 'personalizado',

	'dashboard.title': 'Dashboard',
	'dashboard.members': 'Miembros',
	'dashboard.addMember': 'Añadir miembro',
	'dashboard.sellers': 'Guías Wilma',
	'dashboard.addGuide': 'Añadir guía',
	'dashboard.memberships': 'Membresías',

	'police.limitText': 'Limite de indemnización de tu membresía',
	'police.premium': 'Prima',
	'police.expeditionAmount': 'Gastos de expedición',
	'police.iva': 'IVA',
	'police.resume': 'Resumen de su membresía',
	'police.contractor': 'Contratante',

	'forms.loginTitle': 'Inicia sesión',
	'forms.login': 'Iniciar sesión',
	'forms.welcomeMessage': 'Ingresa para retomar tus aplicaciones o administrar tus membresías.',
	'forms.userName': 'Nombre de usuario',
	'forms.userNameLabel': 'Ingresa tu nombre de usuario',
	'forms.name': 'Nombre',
	'forms.nameLabel': 'Ingresa tu nombre',
	'forms.lastName': 'Apellido',
	'forms.lastNameLabel': 'Ingresa tu apellido',
	'forms.gender': 'Selecciona tu género',
	'forms.age': 'Edad',
	'forms.ageLabel': 'Ingresa tu edad',
	'forms.whatsapp': 'Número de WhatsApp',
	'forms.whatsappLabel': 'Ingresa tu número de WhatsApp',
	'forms.email': 'Correo',
	'forms.emailLabel': 'Ingresa tu correo',
	'forms.password': 'Contraseña',
	'forms.passwordLabel': 'Ingresa tu contraseña',
	'forms.confirmPassword': 'Confirma tu contraseña',
	'forms.forgetPassword': '¿Olvidaste tu contraseña?',
	'forms.wilmaGuide': 'Guía Wilma (opcional)',
	'forms.wilmaGuideLabel': 'Ingresa el código de tu guía Wilma',
	'forms.register': 'Registrarme',
	'forms.newUser': 'Nuevo usuario',
	'forms.tellUs': 'Cuéntanos más sobre ti',
	'forms.nameCorporate': 'Nombre o razón social',
	'forms.contractor': 'Nombre del contratante',
	'forms.contractorLabel': 'Ingresa el nombre del contratante',
	'forms.streetAndNumber': 'Calle y número',
	'forms.streetAndNumberLabel': 'Ingresa tu calle y número',
	'forms.state': 'Estado',
	'forms.companyCity': 'Población/municipio',
	'forms.companyCityLabel': 'Ingresa tu población/municipio',
	'forms.colony': 'Colonia',
	'forms.colonyLabel': 'Ingresa tu colonia',
	'forms.zipCode': 'Código Postal',
	'forms.zipCodeLabel': 'Ingresa tu código postal',
	'forms.rfc': 'RFC',
	'forms.rfcLabel': 'Ingresa tu RFC',
	'forms.activity': 'Actividad',
	'forms.businessLine': 'Selecciona tu actividad',
	'forms.commercialName': 'Nombre comercial',
	'forms.commercialNameLabel': 'Ingresa tu nombre comercial',
	'forms.numberOfEmployees': 'Número de empleados',
	'forms.largeRevenue': '¿Tus ingresos por facturación anual son superiores a $235,000,000?',
	'forms.largeRevenueM1':
		'Nuestra membresía esta enfocada en ayudar al sector PYME, por favor contacta a uno se nuestros asesores para hacerte una solución a la medida.',
	'forms.largeRevenueM2':
		'Si te interesa adquierir una de nuestras membresías, contáctanos para poderte brindar más información.',
	'forms.chooseMembership': 'Escoge una de nuestras membresías',
	'forms.selectCity': 'Selecciona una ciudad',
	'forms.selectMembership': 'Selecciona un tipo de membresía',
	'forms.compensationLimit': 'Monto de indemnización',
	'forms.compensationLimitLabel': 'Limite de Indemnización de tu membresía',
	'forms.recover': 'Recuperar',

	'errors.invalidEmail': 'Debe ser un correo válido',
	'errors.invalidPassword': 'La contraseña debe contener al menos 6 caracteres',
	'errors.required': 'Este campo es requerido',
	'errors.minimun': 'El monto mínimo es de $100,000',
	'errors.maximum': 'El monto máximo es de $7,000,000',

	'label.male': 'Masculino',
	'label.female': 'Femenino',
	'label.other': 'Prefiero no decirlo',

	'msg.termsAndConditions':
		'Confirmo, bajo protesta decir verdad, que los datos son correctos y que el Contratante tiene bienes o una actividad económica que puede ser afectada por un Huracán dentro del Área de Cobertura seleccionada.',
	'msg.forgotPasswordTitle': 'Recupera tu contraseña',
	'msg.forgotPassword': 'Ingresa tu correo y te enviaremos una liga para recuperar tu contraseña.',
	'msg.newUserTitle': '¡Únete a la comunidad Wilma!',
	'msg.newUser': 'Ingresa los siguientes datos',
	'msg.shortTerms': 'Acepto los términos y condiciones',
	'msg.seeTerms': 'Ver términos y condiciones',

	'account.title': 'Mi cuenta',
	'account.membership': 'Mis membresías',
	'account.noMembership': 'No tienes suscripciones activas',
	'account.completeProcess': 'Completar proceso',
	'account.noProcess': 'No tienes procesos incompletos',
	'account.welcome': 'Bienvenido',
	'account.validFrom': 'Válida desde',
	'account.validUntil': 'Válida hasta',
	'account.policy': 'Póliza',

	'members.title': 'Miembros',

	'guides.title': 'Guías Wilma',

	'memberships.title': 'Membresías',

	'allies.title': 'Aliados',

	'quotes.title': 'Cotizaciones',

	'endSeason.p1':
		'LA TEMPORADA 2026 HA CONCLUIDO, MUY PRONTO CONTAREMOS CON LOS COSTOS PARA LA TEMPORADA 2027 Y TÚ SERÁS EL PRIMERO EN CONOCERLOS.',
	'endSeason.p2': 'JUNTOS POR UNA COMUNIDAD PREPARADA.',
	'endSeason.button': 'Regresar',
	'endSeason.p3': '<strong>La temporada de huracanes 2026 ha sido todo un éxito.</strong>',
	'endSeason.p4':
		'A partir del <strong>30 DE SEPTIEMBRE, LA TEMPORADA 2026 ESTÁ CERRADA</strong>, por lo que no es posible contratar nuevas membresías. En enero de 2027, contaremos con las tarifas de la próxima temporada y nuestros Aliados Wilma serán los primeros en conocerlas. Juntos por una comunidad preparada.',
};

export default messages_es;
